import {Directive, ViewContainerRef} from '@angular/core';

@Directive({standalone: true, selector: '[pubDictSelect]'})
export class DictionarySelectorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}
